<template>
  <div>
    <!-- Hero Section -->
    <section class="pt-32 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center">
          <h1 class="text-5xl md:text-6xl font-headings mb-6 text-secondary-900">
            Sign Up for a Free Account

          </h1>
          <p class="text-xl text-secondary-600 max-w-xl mx-auto">
            No credit card required. No contracts to sign. Just sign up and start exploring the full potential of what Entegy can do for your events.
          </p>
        </div>
      </div>
    </section>

    <ContentWrapper>
      <div class="text-white flex flex-col md:flex-row items-center justify-center pb-24">
        <div class="w-full md:w-1/2">
          <img :src="signupImage" alt="Sign Up for a Free Account"
            class="w-full object-cover h-64 md:h-[500px] rounded-br-4xl rounded-tl-4xl">
        </div>
        <div class="w-full md:w-1/2">
          <div ref="hubspotFormRef" id="hubspot-form-container">
            <div class="flex items-center justify-center">
              Loading...
            </div>
          </div>
        </div>
      </div>
    </ContentWrapper>

    <CtaTeam />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'
import CtaTeam from '@/components/Blocks/CtaTeam.vue'
import signupImage from '@/images/photography/full/entegy-5.png'
const hubspotFormRef = ref(null)

function loadHubSpotForm() {
  if (typeof hbspt === 'undefined') {
    const script = document.createElement('script')
    script.src = '//js-ap1.hsforms.net/forms/embed/v2.js'
    script.charset = 'utf-8'
    script.async = true
    script.onload = () => createHubSpotForm()
    document.head.appendChild(script)
  } else {
    createHubSpotForm()
  }
}

function createHubSpotForm() {
  if (hubspotFormRef.value && typeof hbspt !== 'undefined') {
    hbspt.forms.create({
      portalId: '20525915',
      formId: 'c42dfc4d-f6b4-4577-b64a-2c31c4520bf3',
      region: 'ap1',
      target: '#hubspot-form-container'
    })
  }
}

onMounted(() => {
  loadHubSpotForm()
})
</script>
